import React, { useContext } from "react";
import { cardMediaClasses } from "./CardMedia.style";
import { CardContext } from "@/Card/CardContext";
import { useRender } from "@base-ui-components/react/use-render";
import { mergeProps } from "@base-ui-components/react/merge-props";

export type CardMediaProps =
  | (useRender.ComponentProps<"img"> & {
      src: string;
      alt?: string;
      className?: string;
    })
  | (useRender.ComponentProps<"div"> & {
      src?: undefined;
      alt?: undefined;
      className?: string;
    });

export const useCardMedia = (props: CardMediaProps) => {
  const { src, className, render, alt, ref, ...rest } = props;
  const { mediaPosition } = useContext(CardContext);

  const defaultElementType = src ? "img" : "div";
  const element = render ?? React.createElement(defaultElementType);

  const defaultProps: useRender.ElementProps<typeof defaultElementType> = {
    ...(src && { src, alt }),
    className: cardMediaClasses({
      position: mediaPosition,
      class: className,
      isMedia: src !== undefined,
    }),
    ref,
  };

  const renderElement = useRender({
    render: element,
    props: mergeProps<typeof defaultElementType>(defaultProps, rest),
  });

  return renderElement;
};
